import script from "./expenses-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./expenses-report-table.vue?vue&type=script&setup=true&lang=js"

import "./expenses-report-table.vue?vue&type=style&index=0&id=efc37cb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efc37cb2"]])

export default __exports__